// menu_test/lib.coffee formatSeconds port. Accepts a number or a pre-formatted numeric
// string (callers pass formatAmounts output): '8.1s', '1s'.
export const formatSeconds = value => `${parseFloat(Number(value).toFixed(1))}s`
